/**
 * Options for columns that can define a length of the column type.
 */
export interface ColumnWithLengthOptions {

    /**
     * Column type's length.
     * For example type = "varchar" and length = "100" means ORM will create a column with type varchar(100).
     */
    length?: string|number;

}
